import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import numeral from 'numeral';
import moment from 'moment';

import BlankState from '../../../components/BlankState';
import Page from '../../../components/Page';
import DataTable from '../../../components/DataTable';
import { TabHolder, Tab } from '../../../components/Tabs';

import Modal from '../../../components/Modal';

import AddCompany from './open-covers/AddCompany';
import AddOpenCover from './open-covers/AddOpenCover';
import AddCorporateUser from './open-covers/AddCorporateUser';

import {
  listCovers,
  listCompanies,
  listCorporates
} from '../../../actions/openCovers';

class OpenCover extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props;
    this.state = {
      activeCover: {},
      activeCompany: {},
      activeCorporate: {},
      filter: {
        insurer: user.userInfo.insurer
      }
    };
  }

  componentDidMount() {
    const { listCovers, listCompanies, listCorporates } = this.props;
    const insurer = this.props.user.userInfo.insurer;

    listCovers(this.state.filter);
    listCompanies(insurer);
    listCorporates(this.state.filter);
  }

  editOpenCover(open_cover) {
    this.setState({ active_cover: open_cover });
  }

  resetForms = () => {
    this.setState({
      activeCover: {},
      activeCompany: {},
      activeCorporate: {}
    });
  };

  editOpenCover = openCover => {
    this.setState({ activeCover: openCover });
  };

  editCompany = company => {
    this.setState({ activeCompany: company });
  };

  editCorporate = corporate => {
    const { company, insurer, user } = corporate;

    this.setState({
      activeCorporate: {
        company,
        insurer,
        ...user
      }
    });
  };

  render() {
    const menuItems = [
      { id: 'oc', name: 'Open Covers', active: true },
      { id: 'companies', name: 'Companies' },
      { id: 'all-corps', name: 'Corporate Users' }
    ];

    const { activeCover, activeCompany, activeCorporate } = this.state;
    const {
      openCovers,
      corporates,
      companies,
      coversLoading,
      companiesLoading,
      corporatesLoading
    } = this.props.covers;

    return (
      <Page isAdminPage={true} pageTitle="Open Covers">
        <div className="clearfix">
          <TabHolder menuItems={menuItems}>
            <Tab menuId={menuItems[0].id} isActive={true}>
              <button
                data-toggle="modal"
                data-target=".open-cover-modal"
                className="btn btn-success btn-sm btn-add-list"
              >
                <span className="icon ion-plus" /> Add Open Cover
              </button>
              <hr />

              {openCovers.length > 0 ? (
                <DataTable
                  tableId="oc-table"
                  columnTitles={[
                    'Policy No.',
                    'Company',
                    'Upper Limit (TZS.)',
                    'Valid Till',
                    'Custom Rates',
                    'Actions'
                  ]}
                >
                  {openCovers.map((cover, index) => {
                    const {
                      company_name,
                      upper_limit,
                      policy_number,
                      valid_to,
                      is_custom_rates
                    } = cover;

                    return (
                      <tr key={index}>
                        <td>{policy_number}</td>
                        <td>{company_name}</td>
                        <td>{numeral(upper_limit).format('0,0')}</td>
                        <td>{moment(valid_to).format('MMM Do, YYYY')}</td>
                        <td>
                          <span
                            className={
                              'label label-' +
                              (is_custom_rates ? 'success' : 'warning')
                            }
                          >
                            {is_custom_rates ? 'Yes' : 'No'}
                          </span>
                        </td>
                        <td>
                          <button
                            data-toggle="modal"
                            data-target=".open-cover-modal"
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              this.editOpenCover(cover);
                            }}
                          >
                            <span className="icon ion-edit" /> Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={openCovers}
                  dataName="Open Covers"
                  isDataLoading={coversLoading}
                />
              )}

              <Modal
                title="Open Cover"
                className="open-cover-modal"
                closable={true}
                onCloseFn={this.resetForms}
              >
                {activeCover.hasOwnProperty('id') ? (
                  <AddOpenCover editCover={activeCover} />
                ) : (
                  <AddOpenCover />
                )}
              </Modal>
            </Tab>

            <Tab menuId={menuItems[1].id}>
              <button
                data-toggle="modal"
                data-target=".company-modal"
                className="btn btn-success btn-sm btn-add-list"
              >
                <span className="icon ion-plus" /> Add Company
              </button>
              <hr />

              {companies.length > 0 ? (
                <DataTable
                  tableId="companies-table"
                  columnTitles={[
                    'Company',
                    'Phone No.',
                    'Tax ID No.',
                    'Postal Address',
                    'Email',
                    'Actions'
                  ]}
                >
                  {companies.map((company, index) => {
                    const {
                      name,
                      phone,
                      tra_pin,
                      postal_address,
                      email
                    } = company;

                    return (
                      <tr key={index}>
                        <td>{name}</td>
                        <td>{phone}</td>
                        <td>{tra_pin}</td>
                        <td>{postal_address}</td>
                        <td>{email}</td>
                        <td>
                          <button
                            data-toggle="modal"
                            data-target=".company-modal"
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              this.editCompany(company);
                            }}
                          >
                            <span className="icon ion-edit" /> Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={companies}
                  dataName="Companies"
                  isDataLoading={companiesLoading}
                />
              )}

              <Modal
                title="Company"
                className="company-modal"
                closable={true}
                onCloseFn={this.resetForms}
              >
                {activeCompany.hasOwnProperty('id') ? (
                  <AddCompany editCompany={activeCompany} />
                ) : (
                  <AddCompany />
                )}
              </Modal>
            </Tab>

            <Tab menuId={menuItems[2].id}>
              <button
                data-toggle="modal"
                data-target=".corporate-modal"
                className="btn btn-success btn-sm btn-add-list"
              >
                <span className="icon ion-plus" /> Add Corporate User
              </button>
              <hr />

              {corporates.length > 0 ? (
                <DataTable
                  tableId="corps-table"
                  columnTitles={[
                    'Name',
                    'Company',
                    'Postal Address',
                    'Email',
                    'Helpline',
                    'Actions'
                  ]}
                >
                  {corporates.map((corporate, index) => {
                    const { company_name, user } = corporate;

                    return (
                      <tr key={index}>
                        <td>{`${user.first_name} ${user.other_names} ${
                          user.last_name
                        }`}</td>
                        <td>{company_name}</td>
                        <td>{user.postal_address || '-'}</td>
                        <td>{user.email}</td>
                        <td>{user.phone}</td>
                        <td>
                          <button
                            data-toggle="modal"
                            data-target=".corporate-modal"
                            className="btn btn-warning btn-sm"
                            onClick={() => {
                              this.editCorporate(corporate);
                            }}
                          >
                            <span className="icon ion-edit" /> Edit
                          </button>
                        </td>
                      </tr>
                    );
                  })}
                </DataTable>
              ) : (
                <BlankState
                  data={corporates}
                  dataName="Corporate Users"
                  isDataLoading={corporatesLoading}
                />
              )}
              <Modal
                title="Corporate User"
                className="corporate-modal"
                closable={true}
                onCloseFn={this.resetForms}
              >
                {activeCorporate.hasOwnProperty('id') ? (
                  <AddCorporateUser editCorporate={activeCorporate} />
                ) : (
                  <AddCorporateUser />
                )}
              </Modal>
            </Tab>
          </TabHolder>
        </div>
      </Page>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  covers: state.covers,
  insurers: state.insurers,
  user: state.user
});

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { listCovers, listCompanies, listCorporates },
    dispatch
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenCover);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/OpenCover.jsx